import { put, call, fork, select, takeEvery, all } from 'redux-saga/effects';

import * as paymentsModule from '../modules/payments.module';
import * as Api from '../../core/api';

export function* fetchPaymentDetails({ payload: { page, itemsPerPage } }) {
  const sort = yield select((state) => state.payments.sort);
  const account = yield select((state) => state.account);
  const filter = yield select((state) => state.payments.filter);

  const { response, error } =
    yield call(Api.payments.fetchPaymentDetails,
      { page, itemsPerPage, sort, role: account.role, filter });

  if (response) {
    yield put(paymentsModule.fetchPaymentDetailsSuccess(response));
  } else {
    yield put(paymentsModule.fetchPaymentDetailsFail(error));
  }
}
export function* watchFetchPaymentDetails() {
  yield takeEvery(paymentsModule.fetchPaymentDetails.getType(), fetchPaymentDetails);
}

export function* fetchPaymentsTotalBalance() {
  const { response, error } =
    yield call(Api.payments.fetchPaymentsTotalBalance);

  if (typeof response !== 'undefined') {
    yield put(paymentsModule.fetchPaymentsTotalBalanceSuccess({ totalBalance: response }));
  } else {
    yield put(paymentsModule.fetchPaymentsTotalBalanceFail(error));
  }
}
export function* watchFetchPaymentsTotalBalance() {
  yield takeEvery(paymentsModule.fetchPaymentsTotalBalance.getType(), fetchPaymentsTotalBalance);
}

export function* setPaymentPaid({ payload: { externalId, status } }) {
  const { response, error } = yield call(Api.payments.setPaymentPaid, { externalId, status });

  if (typeof response !== 'undefined') {
    yield put(paymentsModule.setPaymentPaidSuccess({ payment: response }));
  } else {
    yield put(paymentsModule.setPaymentPaidFail(error));
  }
}
export function* watchSetPaymentPaid() {
  yield takeEvery(paymentsModule.setPaymentPaid.getType(), setPaymentPaid);
}

export function* refreshBalance({ payload = {} }) {
  const { response, error } = yield call(Api.payments.refreshBalance, { period: payload.period });

  if (typeof response !== 'undefined') {
    const sort = yield select((state) => state.payments.sort);
    const page = yield select((state) => state.payments.currentPage) || 1;
    const filter = yield select((state) => state.payments.filter);
    const account = yield select((state) => state.account);

    const { response: payments, error: paymentsError } =
      yield call(Api.payments.fetchPaymentDetails, { page, itemsPerPage: 10, sort, role: account.role, filter });

    if (payments) {
      yield put(paymentsModule.refreshBalanceSuccess(response));
      yield put(paymentsModule.fetchPaymentDetailsSuccess(payments));
    } else {
      yield put(paymentsModule.refreshBalanceFail(paymentsError));
    }
  } else {
    yield put(paymentsModule.refreshBalanceFail(error));
  }
}
export function* watchRefreshBalance() {
  yield takeEvery(paymentsModule.refreshBalance.getType(), refreshBalance);
}

export function* getPeriods() {
  const { response, error } = yield call(Api.payments.getPeriods);

  if (typeof response !== 'undefined') {
    yield put(paymentsModule.getPeriodsSuccess({ periods: response }));
  } else {
    yield put(paymentsModule.getPeriodsFail(error));
  }
}
export function* watchGetPeriods() {
  yield takeEvery(paymentsModule.getPeriods.getType(), getPeriods);
}

export function* getLastRefreshDate() {
  const { response, error } = yield call(Api.payments.getLastRefreshDate);

  if (typeof response !== 'undefined') {
    yield put(paymentsModule.getLastRefreshDateSuccess(response));
  } else {
    yield put(paymentsModule.getLastRefreshDateFail(error));
  }
}
export function* watchGetLastRefreshDate() {
  yield takeEvery(paymentsModule.getLastRefreshDate.getType(), getLastRefreshDate);
}

export function* getNextPaymentCycle() {
  const { response, error } = yield call(Api.payments.getNextPaymentCycle);

  if (typeof response !== 'undefined') {
    yield put(paymentsModule.getNextPaymentCycleSuccess(response));
  } else {
    yield put(paymentsModule.getNextPaymentCycleFail(error));
  }
}
export function* watchGetNextPaymentCycle() {
  yield takeEvery(paymentsModule.getNextPaymentCycle.getType(), getNextPaymentCycle);
}

export function* processPayments({ payload: { file, process } }) {
  const { response, error } = yield call(Api.payments.processPayments, { file, process });

  if (typeof response !== 'undefined') {
    yield put(paymentsModule.processPaymentsSuccess({ response, process }));
    if (process) {
      yield fetchPaymentDetails({ payload: { page: 1, itemsPerPage: 10 } });
    }
  } else {
    yield put(paymentsModule.processPaymentsFail(error));
  }
}
export function* watchProcessPayments() {
  yield takeEvery(paymentsModule.processPayments.getType(), processPayments);
}

export default function* watchPayments() {
  return yield all([
    fork(watchFetchPaymentDetails),
    fork(watchFetchPaymentsTotalBalance),
    fork(watchSetPaymentPaid),
    fork(watchRefreshBalance),
    fork(watchGetPeriods),
    fork(watchGetLastRefreshDate),
    fork(watchGetNextPaymentCycle),
    fork(watchProcessPayments),
  ]);
}




/** WEBPACK FOOTER **
 ** ./js/redux/saga/payments.saga.js
 **/